import { Icon } from "@iconify/react";
import type { components } from "../helper";
import { formatSizeUnits, GetFullMediaPath } from "../helper/method";

export default function AttachmentsItem({
  data,
}: {
  data: components["schemas"]["SiteTicketDetailFileItem"];
}) {
  return (
    <div className="flex gap-2 group">
      <div className="bg-grayscale-200 rounded-2xl w-11 flex-center h-11">
        <Icon icon={"solar:file-bold-duotone"} className="text-3xl" />
      </div>
      <div className="flex flex-col">
        <a
          target="_blank"
          download={true}
          href={GetFullMediaPath(data.file)}
          className="text-16-regular text-grayscale-950! group-hover:underline"
        >
          {data.file_name}
        </a>
        <span className="text-14-regular text-grayscale-600">
          {formatSizeUnits(data.size.toString())}
        </span>
      </div>
    </div>
  );
}
